export default async (to, from, next) => {
  next()
}
